import { Label } from 'views/components/atoms/label';
import { ListBodyCellType } from 'views/components/atoms/listCell';
import { BodyShowList } from 'views/components/molecules/listBody';
import { BgColors } from 'views/constants/enums/bgColors';
import { formatDate } from 'views/utils/format/FormatDate';
import { formatNumber } from 'views/utils/format/FormatNumber';
import { GetApplicationListQuery, GetApplicationListQueryVariables } from 'views/utils/graphql/graphql';

export const createBodyShowLists = (data: GetApplicationListQuery) => {
  if (!data.GetApplicationList?.Data) return [];

  const createdBodyShowLists: BodyShowList[] = data.GetApplicationList?.Data?.map((item) => {
    const applyQty = Number(item?.TotalApplicationQuantity);
    const purchaseQty = Number(item?.TotalPurchaseQuantity);
    const purchaseAmount = Number(item?.TotalPurchaseAmount);
    // 抽選結果が出る前か?
    // 抽選結果が出る前で0円だったら"-"表示にする
    const isBefourResult = item?.Status !== 3;
    return [
      {
        type: ListBodyCellType.labelCell,
        label: <div>{item?.Status && checkStatusLabel(item?.Status)}</div>,
      },
      {
        type: ListBodyCellType.nameCell,
        label: <div>{item?.SymbolName}</div>,
      },
      {
        type: ListBodyCellType.applyQtyCell,
        label: <div>{`${isBefourResult && applyQty === 0 ? '-' : formatNumber(applyQty)} 口`}</div>,
      },
      {
        type: ListBodyCellType.quantityCell,
        label: <div>{`${isBefourResult && purchaseQty === 0 ? '-' : formatNumber(purchaseQty)} 口`}</div>,
      },
      {
        type: ListBodyCellType.amountCell,
        label: (
          <div>{`${isBefourResult && purchaseAmount === 0 ? '-' : formatNumber(purchaseAmount / 10000)} 万円`}</div>
        ),
      },
      {
        type: ListBodyCellType.dateCell,
        label: <div>{formatDate(item?.LatestApplicationDateTime)}</div>,
      },
      {
        type: ListBodyCellType.refundCell,
        label: <div>{convertLotteryFailureRefundType(item?.LotteryFailureRefundType!, false)}</div>,
      },
    ];
  });
  return createdBodyShowLists;
};

enum OrderStatus {
  One = '申込締切前',
  Two = '配分前',
  Three = '配分後',
  Four = '申込取消',
}

export const checkStatusLabel = (status: number) => {
  switch (status) {
    case 1:
      return <Label backgroundColor={BgColors.Safe} content={OrderStatus.One.toString()} />;
    case 2:
      return <Label backgroundColor={BgColors.Secondary} content={OrderStatus.Two.toString()} />;
    case 3:
      return <Label backgroundColor={BgColors.Primary} content={OrderStatus.Three.toString()} />;
    case 4:
      return <Label backgroundColor={BgColors.Danger} content={OrderStatus.Four.toString()} />;
  }
};

export const convertLotteryFailureRefundType = (refundType: String, isDetail: boolean = false) => {
  switch (refundType) {
    case '1':
      return isDetail ? 'ご登録銀行口座への返金' : '登録銀行口座';
    case '2':
      return isDetail ? 'FPG証券お客様口座にて預り金として管理' : 'お預かり金';
    default:
      return '';
  }
};
